import React from 'react'

interface IProps {
  label?: string
  value?: string
  name?: string
  error?: string
  placeholder?: string
  onChange: (value: string) => void
}

const TextArea: React.FC<IProps> = props => {
  const { label, value, name, placeholder, error } = props

  const handleChange = (e: React.ChangeEvent<HTMLTextAreaElement>) => {
    const { value } = e.target
    if (props.onChange) {
      props.onChange(value)
    }
  }

  return (
    <div className="w-full">
      {label && (
        <label htmlFor={name} className={`label ${error && 'text-red'}`}>
          {label}
        </label>
      )}
      <textarea
        id={name}
        name={name}
        rows={6}
        onChange={handleChange}
        className={`w-full border-1 ${
          error ? 'border-red' : 'border-gray-200'
        } py-15 px-20 text-black font-500 text-15 leading-22 tracking-0.12`}
        value={value}
        placeholder={placeholder}
        style={{
          resize: 'none',
        }}
      />
    </div>
  )
}

export default TextArea
